import React, {useState} from 'react';
import PropTypes from 'prop-types';
import IconButton from "../../../../common/IconButton";
import {faSignature} from "@fortawesome/free-solid-svg-icons";
import {Spinner} from "react-bootstrap";
import SelectCertificateWrapperComponent from "../../components/SelectCertificateWrapperComponent";
import {selectLang, Translate} from "../../../../../app/store/reducers/main/mainReducer";
import {useSelector} from "react-redux";
import {sendAsync} from "../../../../../app/store/reducers/roaming/roamingInvoiceReducer";
import {selectCurrentCertificate} from "../../../../../app/store/reducers/eimzo/eimzoReducer";
import EventBus from "../../../../../app/eventbus/EventBus";
import {
    ROAMING_INVOICE_BULK_ACTION_FINISHED,
    ROAMING_INVOICE_BULK_ACTION_STARTED
} from "../../../../../app/eventbus/roaming/roamingInvoiceEvents";

const HybridInvoiceDraftSend = ({invoice, invoices, handleShowProgressBar, updateActionResult, ...props}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const activeCertificate = useSelector(selectCurrentCertificate);

    // button loader
    const [loading, setLoading] = useState(false);

    // send
    const send = () => {
        if (invoices.length > 0)
            bulkSend();
        else
            singleSend();
    }

    // single send document
    const singleSend = () => {
        setLoading(true);
        sendAsync(activeCertificate, lang, invoice.content)
            .then(() => {
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            })
    }

    // bulk send document
    const bulkSend = async () => {
        handleShowProgressBar();
        EventBus.dispatch(ROAMING_INVOICE_BULK_ACTION_STARTED);

        const taskSize = 10;
        const tasks = []

        const signer = async invoice => {
            try {
                await sendAsync(activeCertificate, lang, invoice.content);
                updateActionResult({
                    number: invoice.info.number,
                    date: invoice.info.date,
                    contractor: {
                        name: invoice.customer.name,
                        inn: invoice.customer.inn
                    }
                });
            } catch (error) {
                updateActionResult({
                    number: invoice.info.number,
                    date: invoice.info.date,
                    contractor: {
                        name: invoice.customer.name,
                        inn: invoice.customer.inn
                    },
                    error: error?.message
                })
            }
        }

        for (let i = 0; i < invoices.length; i++) {
            tasks.push(signer(invoices[i]))

            if (tasks.length >= taskSize) {
                await Promise.all(tasks)
                tasks.splice(0, tasks.length)
            }
        }

        if (tasks.length > 0) {
            await Promise.all(tasks)
            tasks.splice(0, tasks.length)
        }
        EventBus.dispatch(ROAMING_INVOICE_BULK_ACTION_FINISHED);
    }


    return (
        <SelectCertificateWrapperComponent submitButton={
            <IconButton icon={faSignature}
                        variant="falcon-primary"
                        id="Send"
                        disabled={loading}
                        onClick={send}
                        className="m-1"
                        {...props}
            >
                {loading && <Spinner size="sm" className='align-middle me-2' animation='border' role='switch'/>}
                {t(lang, "roaming.invoice.send_button")}
            </IconButton>
        }
                                           openDialogButtonText={t(lang, "roaming.invoice.send_button")}
        />
    );
};

export default HybridInvoiceDraftSend;

HybridInvoiceDraftSend.propTypes = {
    invoice: PropTypes.object,
    invoices: PropTypes.array,
    updateActionResult: PropTypes.func,
    handleShowProgressBar: PropTypes.func
}

HybridInvoiceDraftSend.defaultProps = {
    invoice: {},
    invoices: [],
    updateActionResult: () => {
    },
    handleShowProgressBar: () => {}
}
